var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M259,507.2C120.4,507.9,6.7,392.7,9.9,252.1c3-134,114.1-245,252.4-243.4c136.6,1.6,249.4,115.4,245.8,256   C504.7,398.1,394.7,507.8,259,507.2z M40.2,258.2C41.3,383.5,142.6,479.8,262.4,478c116.2-1.8,215.2-96.4,215.3-220   c0-125.2-102.1-222-222.2-220C139.1,39.9,41,134.7,40.2,258.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.6,375.6c0-2.2,0-4.1,0-6.1c0-26.7,0.1-53.3-0.1-80c0-4.6-0.4-9.4-1.5-13.8c-3.6-14.8-15.6-22.2-32.9-20.8   c-12.8,1-24.3,12.4-25.2,25.6c-0.6,8-0.4,16-0.5,24c-0.1,21.7,0,43.3,0,65c0,2,0,3.9,0,6.2c-16.2,0-32,0-48.1,0   c0-52,0-104.1,0-156.4c15.7,0,31.4,0,47.7,0c0,6.1,0,12.3,0,19.8c1.7-2,2.7-3,3.4-4.2c21.6-32.4,80.2-28.9,97.6,9.3   c4.8,10.6,7.7,21.7,7.8,33.3c0.3,32.1,0.2,64.3,0.2,96.5c0,0.5-0.1,1-0.3,1.8C358.9,375.6,343,375.6,326.6,375.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5,375.8c-16.1,0-31.7,0-47.7,0c0-51.9,0-103.6,0-155.6c15.9,0,31.6,0,47.7,0C187.5,271.9,187.5,323.6,187.5,375.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.2,189c-14.3-0.1-24.3-10.5-24.2-24.9s10.5-24.3,25.4-24.2c14.2,0.1,24.5,10.6,24.3,24.9   C187.7,179,177,189.1,162.2,189z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.389e0c0c3a1f656f7de0a0c1c4606058.svg";
export { ForwardRef as ReactComponent };